// `Documentation_PageVideoData.aspectRatio` is stored as `width:height`
// (e.g. `16:9`) — industry convention for video, design, ads. The CSS
// `aspect-ratio` property is the outlier: it only accepts `width / height`
// (or `width/height`). Convert at the rendering boundary; never persist
// the slash form.
export function toCssAspectRatio(stored: string | null | undefined): string {
  if (!stored) return '16 / 9';
  return stored.includes(':') ? stored.replace(':', ' / ') : stored;
}

// Video durations are stored as integer seconds. Render as
// `mm:ss` (under 1 hour) or `h:mm:ss` (1 hour or more).
// Sub-minute values come out as `0:42` to keep the colon grouping
// consistent with the rest of the helper's output.
export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '';
  const totalSeconds = Math.round(seconds);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return hours > 0
    ? `${hours}:${pad(minutes)}:${pad(secs)}`
    : `${minutes}:${pad(secs)}`;
}
